import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsAPI from '@/lib/api/analytics';
import { useAuth } from '@/contexts/AuthContext';
import { whenAuthenticatedSessionReady } from '@/lib/utils/analytics-session';
import logger from '@/lib/utils/logger';
import { buildPageViewEventPayload } from '@/lib/utils/page-view-event';

export function PageViewTracker(): null {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    const sendPageView = async (): Promise<void> => {
      const result = await analyticsAPI.events.track(
        buildPageViewEventPayload(location.pathname, location.search, document.referrer, navigator.userAgent)
      );

      if (result === null) {
        logger.warn('Authenticated page view was not recorded', { path: location.pathname });
      }
    };
    if (!user) return;
    return whenAuthenticatedSessionReady(() => {
      void sendPageView();
    });
  }, [location, user]);

  return null;
}
